module.exports = __webpack_public_path__ + "img/login_bg.e2ca8ac.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/login_bg.png
// module id = 1/O3
// module chunks = 85